// The workspace's one mount point for the 2026-10-18 parity extras that are not tied to a row or a
// pane: the acknowledgement sheet (P346), the thread windows' host (P317), the attention blink
// (P337) and the F6 pane keys + Ctrl+Tab step (P339).
import { useContext, useEffect } from 'react';
import { ShellContext } from '../../shell/ShellContext';
import { AcknowledgementHost } from './AcknowledgementSheet';
import { useAttentionBlink } from './attention';
import { usePaneKeys } from './keyboard';
import { publishThreadWindowHost } from './threadWindow';

export function ExtrasHost({ mentions, stepConversation }: { mentions: number; stepConversation(direction: 'previous' | 'next'): void }) {
  const shell = useContext(ShellContext);
  useEffect(() => publishThreadWindowHost(shell), [shell]);
  useAttentionBlink(mentions);
  usePaneKeys(stepConversation);
  return <AcknowledgementHost />;
}
